import { LocgSectionEvents } from '@app/code/src/machines/locg/locgMachine.types'
import { useGlobalServices } from '@app/common/src/hooks/useGlobalServices'
import { useSelector } from '@xstate/react'
import React, { useEffect, useRef } from 'react'

export interface ScrollableContainerState {
  rootContainerRef: React.RefObject<HTMLDivElement>
  sectionRefs: React.MutableRefObject<HTMLDivElement[]>
}

export const useScrollableContainerState = (): ScrollableContainerState => {
  const sectionRefs = useRef<HTMLDivElement[]>([])
  const rootContainerRef = useRef<HTMLDivElement>(null)
  const { locgService } = useGlobalServices()
  const observerRef = useRef<IntersectionObserver | null>(null)
  const codeDesign = useSelector(locgService, state => state.matches('codeDesign'))

  useEffect(() => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              locgService.send({
                type: entry.target.id as LocgSectionEvents
              })
            }
          })
        },
        {
          root: rootContainerRef.current,
          threshold: 0.7,
          rootMargin: '0px' // switch to 16px after adding progress bar
        }
      )
    }

    if (sectionRefs.current.length && codeDesign) {
      sectionRefs.current.forEach(element => {
        observerRef.current?.observe(element)
      })
    }

    return () => {
      observerRef.current?.disconnect()
    }
  }, [locgService, codeDesign])

  return {
    sectionRefs,
    rootContainerRef
  }
}
